<script lang="ts">
	import { Link } from 'svelte-routing';

	const copyIcon = '/assets/images/copy.svg';
	export let id: string;
</script>

<Link to="/duplicate_persona/{id}" class="clickable">
	<img class="small clickable" src={copyIcon} alt="Duplicate icon" />
</Link>

<style>
	.clickable {
		cursor: pointer;
	}

	img {
		width: 64px;
		display: block;
	}

	.small {
		width: 24px;
		margin: 0 -8px;
	}
</style>
